import React from 'react'
import { useEffect, useState } from 'react'
import { SEditor, SDrawerOrModal } from 'shj-components'
import { message } from 'antd'
import { updateBizType, updateTrackPlanTag } from '@/services/customerServices.ts'
import check from '@/assets/check.png'
import styles from './index.module.less'
import { updateClueTag } from '@/services/saleOpServices.ts'

const colorList = [
  {
    borderColor: 'rgba(250, 96, 80, 1)',
    fontColor: 'rgba(242, 90, 10, 1)',
  },
  {
    borderColor: 'rgba(0, 100, 255, 1)',
    fontColor: 'rgba(0, 100, 255, 1)',
  },
  {
    borderColor: 'rgba(245, 147, 0, 1)',
    fontColor: 'rgba(245, 147, 0, 1)',
  },
  {
    borderColor: 'rgba(112, 163, 16, 1)',
    fontColor: 'rgba(112, 163, 16, 1)',
  },
]

export default function ChooseTagModal({
  list = [],
  single = false,
  editId = '',
  open = false,
  tagList = [],
  onClose = () => {},
  reload = () => {},
  isBizTag = false,
  getDataOnly = false,
  getSelectTags = (data: any) => data,
}) {
  const [tagData, setTagData] = useState<Array<any>>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setTagData(list)
  }, [list])

  useEffect(() => {
    let resList = list;
    if (tagList.length > 0) {
      const selectedTagIds = tagList.map(tag => tag.tagId || tag.key)
      resList = list.map(item => {
        item.tags?.forEach(tag => tag.choose = selectedTagIds.includes(tag.key))
        return item
      })
    }
    setTagData(resList)
  }, [list])

  const onSubmit = async () => {
    try {
      if (getDataOnly) {
        const selectTags = tagData
          .map(item => {
            return item.tags.filter(tag => tag.choose)
          })
          .filter(item => item.length > 0)
          .flat(Infinity)
        getSelectTags(selectTags)
        onClose()
        return
      } else {
        let res: any = {}
        if (isBizTag) {
          let bizType = ''
          tagData.forEach(item => {
            item?.tags?.forEach(tagItem => {
              if (tagItem?.choose) {
                bizType = tagItem?.key
              }
            })
          })
          setLoading(true)
          res = await updateBizType({
            trackPlanId: editId,
            bizType,
          })
          setLoading(false)
        } else {
          const newTagIdList: any = []
          const oldTagIdList: any = tagList?.map((item: any) => ({ key: item?.key, id: item?.id }))
          tagData.forEach(item => {
            item?.tags?.forEach(tagItem => {
              if (tagItem?.choose) {
                newTagIdList.push({
                  tagName: tagItem?.description,
                  tagId: tagItem?.key,
                  tagSourceGroupCode: item?.key,
                })
              }
            })
          })

           const deleteTagIdList = oldTagIdList?.map(item => item.id)
           const addTagList = newTagIdList

          setLoading(true)
          res = await updateClueTag({
            addTagList,
            clueId: editId,
            delIds: deleteTagIdList,
          })
          setLoading(false)
        }
        if (res?.errorCode === 0 && res?.status) {
          message.success(`修改标签成功`)
          onClose()
          reload()
        } else {
          message.error(`修改标签失败`)
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const chooseTag = (tag, tagItem) => {
    const list = tagData.map(item => {
      if (tag.key === item.key) {
        const taglist = item.tags.map(tagMapItem => {
          if (tagMapItem.key === tagItem.key) {
            return {
              ...tagMapItem,
              choose: !tagMapItem.choose,
            }
          }
          return {
            ...tagMapItem,
            choose: single ? false : tagMapItem.choose,
          }
        })
        return {
          ...item,
          tags: taglist,
        }
      }
      return {
        ...item,
      }
    })
    console.log(list)
    setTagData(list)
  }

  return (
    <div className={styles.chooseTagModal}>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width={600}
        title="请选择标签"
      >
        {tagData &&
          tagData.map(tag => (
            <div>
              <div className={styles.titleBox}>
                <div className={styles.titleFont}>{tag.title}</div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  width: 'fit-content',
                }}
              >
                {tag.tags &&
                  tag.tags.map((tagItem, index) => (
                    <div
                      onClick={() => chooseTag(tag, tagItem)}
                      style={{
                        position: 'relative',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '22px',
                        padding: '4px 8px',
                        border: `1px solid ${colorList[index % 4]?.borderColor}`,
                        color: colorList[index % 4]?.fontColor,
                        borderRadius: '3px',
                        marginRight: '16px',
                        marginBottom: '12px',
                      }}
                    >
                      {tagItem.description}
                      {tagItem.choose && (
                        <div
                          style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: 0,
                            height: 0,
                            borderColor: `transparent ${colorList[index % 4]?.borderColor}`,
                            borderWidth: '0 0 16px 16px',
                            borderStyle: 'solid',
                          }}
                        ></div>
                      )}
                      {tagItem.choose && (
                        <img
                          style={{ position: 'absolute', left: 0, top: 0, width: 10, height: 10 }}
                          src={check}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </div>
          ))}
      </SDrawerOrModal>
    </div>
  )
}
